import { FormattedMessage } from 'react-intl';
import LanguageCode from '@alltrails/shared/types/LanguageCode';
import useLanguageCode from 'hooks/useLanguageCode';
import useFormatMessage from '@alltrails/shared/hooks/useFormatMessage';
import * as styles from './styles/styles.module.scss';
import CultureStat from './CultureStat';
import OUR_CULTURE_STRINGS from './ourCulture.strings';

const VIDEO_ID_MAP: { [key in LanguageCode]: string } = {
  [LanguageCode.English]: '548955974?h=0d541fd038',
  [LanguageCode.French]: '689475312?h=9683202939',
  [LanguageCode.German]: '689475103?h=69db207e1d',
  [LanguageCode.Spanish]: '689475490?h=3540b9b727',
  [LanguageCode.Danish]: '548955974?h=0d541fd038',
  [LanguageCode.Dutch]: '548955974?h=0d541fd038',
  [LanguageCode.EnglishGB]: '548955974?h=0d541fd038',
  [LanguageCode.Italian]: '548955974?h=0d541fd038',
  [LanguageCode.Norwegian]: '548955974?h=0d541fd038',
  [LanguageCode.Polish]: '548955974?h=0d541fd038',
  [LanguageCode.Portuguese]: '548955974?h=0d541fd038',
  [LanguageCode.PortugueseBrazilian]: '548955974?h=0d541fd038',
  [LanguageCode.SpanishLatAm]: '689475490?h=3540b9b727',
  [LanguageCode.Swedish]: '548955974?h=0d541fd038'
};

const OurCulture = (): JSX.Element => {
  const {
    formattedDefaultMessages: { TEN_K_REASONS, THREE_HUNDRED_K, CURATED_TRAILS, THIRTY_FIVE_MIL, FELLOW_EXPLORERS, ONE, GLOBAL_COMMUNITY }
  } = useFormatMessage(OUR_CULTURE_STRINGS);
  const languageCode = useLanguageCode();
  return (
    <div className={styles.container}>
      <div className={styles.embedFlex}>
        <div className={styles.embedContainer}>
          <iframe
            title={TEN_K_REASONS}
            src={`https://player.vimeo.com/video/${VIDEO_ID_MAP[languageCode]}&color=428A13&title=0&byline=0&portrait=0`}
            className={styles.embedVid}
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>
      <script src="https://player.vimeo.com/api/player.js" />
      <div className={styles.textContent}>
        <h2 className={styles.header}>{TEN_K_REASONS}</h2>
        <div className={styles.desc}>
          <FormattedMessage defaultMessage="The more we grow, the more we realize all the ways that nature connects us: to ourselves, to the past, to the ecosystems we live within, and to each other. Here’s to more trails and more community members with even more reasons to get outside." />
        </div>
        <div className={styles.divider} />
        <div className={styles.statsContainer}>
          <CultureStat title={THREE_HUNDRED_K} subtitle={CURATED_TRAILS} />
          <CultureStat title={THIRTY_FIVE_MIL} subtitle={FELLOW_EXPLORERS} />
          <CultureStat title={ONE} subtitle={GLOBAL_COMMUNITY} />
        </div>
      </div>
    </div>
  );
};

export default OurCulture;
